/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Bring_S1_CapInputs */

const en_funnel_ob_bring_s1_cap = /** @type {(inputs: Funnel_Ob_Bring_S1_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop in anything, even a photo of a page.`)
};

const es_funnel_ob_bring_s1_cap = /** @type {(inputs: Funnel_Ob_Bring_S1_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta lo que sea, incluso la foto de una página impresa.`)
};

/**
* | output |
* | --- |
* | "Drop in anything, even a photo of a page." |
*
* @param {Funnel_Ob_Bring_S1_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_bring_s1_cap = /** @type {((inputs?: Funnel_Ob_Bring_S1_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Bring_S1_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_bring_s1_cap(inputs)
	return en_funnel_ob_bring_s1_cap(inputs)
});